import * as r from "react";
import c from "../lib/IconBase.es.js";
import t from "../defs/CurrencyDollar.es.js";
const o = r.forwardRef((e, a) => /* @__PURE__ */ r.createElement(c, { ref: a, ...e, weights: t }));
o.displayName = "CurrencyDollarIcon";
const m = o;
export {
  m as CurrencyDollar,
  o as CurrencyDollarIcon
};
